import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { TabsPage } from '../tabs/tabs';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  password: string = '';
  error: boolean = false;

  constructor(public navCtrl: NavController, public auth: AuthProvider) {}

  login() {
    if (this.auth.login(this.password)) {
      this.error = false;
      this.navCtrl.setRoot(TabsPage);
    } else {
      this.error = true;
      this.password = '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts